import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField, Button } from '@mui/material';
import { useState, useCallback } from 'react';

interface RejectTicketDialogProps {
  open: boolean;
  onClose: () => void;
  onReject: (comments: string) => Promise<void>;
  isRejecting: boolean;
}

export function RejectTicketDialog({ open, onClose, onReject, isRejecting }: RejectTicketDialogProps) {
  const [comments, setComments] = useState('');
  
  const handleSubmit = useCallback(async () => {
    await onReject(comments);
    setComments('');
  }, [comments, onReject]);
  
  const handleClose = useCallback(() => {
    setComments('');
    onClose();
  }, [onClose]);
  
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Reject Ticket</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please provide a reason for rejecting this ticket.
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id="comments"
          label="Rejection Comments"
          type="text"
          fullWidth
          multiline
          rows={4}
          value={comments}
          onChange={(e) => setComments(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button 
          onClick={handleSubmit} 
          color="error" 
          disabled={isRejecting}
        >
          {isRejecting ? 'Rejecting...' : 'Confirm Rejection'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}